<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13hxizp/tc-custom/9781429903691.jpg?1722309730410" alt="This image is the cover for the book Daughter-In-Law"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Daughter-In-Law
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In the latest thriller from <i>New York Times</i> bestselling author of the <i>Good Sister</i>, trouble with the in-laws is taken to the extreme - with deadly results.  From the steamy Caribbean tropics to the penthouses of New York City, dark secrets and bitter rivalry push a new bride and her mother-in-law to the very edge in this gripping novel of seduction and murder</b><br/><br/>The oldest son of the rich and powerful Donner family, Jonathan, prefers to remain a playboy, rather than take over the financial and social responsibilities of his family's business empire.   But in a near fatal skydiving accident, Jonathan saves the life a radiant young woman, Nicole Pierce.  Like no one else he has ever met, she is confident, independent and seemingly impressed by his fortune. Captivated by her beauty and intrigued by her mysterious past, Jonathan is determined to make Nicole his.   After a whirlwind romance, the two lovers elope and begin a long honeymoon in the Caribbean. <br/><br/>Returning to the Donner family estate, Nicole is immediately embraced by the family.  For John's younger sister and father, she is a breath of fresh air.  But not everyone has fallen for her.  Jonathan's dominant and powerful mother, Alexandra Donner, believes the newest member of the family is more interested in money than in her son. <br/><br/>Then, tragedy strikes and Jonathan is killed in a scuba diving accident, leaving Nicole to return to the family's compound, a young and tragic widow. But her mother-in-law thinks her son's death was no accident.  Was he murdered?  Could Nicole be behind the accident?  Or, is Alexanrda jealous of her daughter-in-law?  Alexendra sets out to prove Nicole's guilt and begins to uncover a web of lies and secrets.  Mother-in-law and daughter-in-law come face to face in a gripping climax.   The truth is far from clear as this gripping thriller twists and turns to its shocking conclusion. <br/><br/>" … fans of Diamond's previous work will find the book entertaining enough for a day at the beach." -<i> Publishers Weekly</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diana Diamond
      </h2>
      
      <p class="authorDescription body article"><P><B>Diana Diamond</B> is the pseudonym of a bestselling mystery and thriller writer, author of <I>The Trophy Wife </I>and <I>The Good Sister</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b1c4d7a